// extracted by mini-css-extract-plugin
export var container = "_2p-0";
export var error = "_2p-9";
export var label = "_2p-5";
export var light = "_2p-6";
export var md = "_2p-3";
export var sm = "_2p-2";
export var thin = "_2p-8";
export var thinBold = "_2p-7";
export var vertical = "_2p-4";
export var xs = "_2p-1";